import acceptedCookiePolicy from "../../../../components/onetrust/cookiePolicy";

const ifCanPushDatalayer = (config = {}) => {
	const then = config.then || null;

	acceptedCookiePolicy({
		ifTargetingCookies: () => {
			if (typeof dataLayer !== 'undefined') {
				then();
			}
		}
	});
};

const urlIncludes = (segment) => {
	return window.location.href.includes(segment);
};

const pageTypeIncludes = (string) => {
	const dataPage = document.querySelector(`html[data-page*=${string}]`);
	const page = dataPage ? dataPage.dataset.page : '';

	return page.includes(string);
};

export {
	ifCanPushDatalayer,
	urlIncludes,
	pageTypeIncludes
};
